import { getPiralComponent } from 'piral-core';
export const PiralBreadcrumbsContainer = getPiralComponent('BreadcrumbsContainer');
export const PiralBreadcrumbItem = getPiralComponent('BreadcrumbItem');
//# sourceMappingURL=components.js.map